import { DOCUMENT } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Company, ConnectionService } from '../../services/Connection/connection.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'splash',
  templateUrl: './splash.component.html',
  styleUrls: ['./splash.component.css']
})
export class SplashComponent implements OnInit, AfterViewInit {

  //#region Variaveis de elemento HTML
    @ViewChild('splash') splash!: ElementRef;
    @ViewChild('img') img!: ElementRef;
    imgLoaded: boolean = false;
    // imgString: string = './assets/logo/Gif/animation-logo.gif';
  //#endregion

  //#region Variaveis Locais
    preloadedImage!: HTMLImageElement;
    pauseGif: boolean = false;
    company!: Company;
    imgString: string = ''
    version: string = environment.version;
  //#endregion

  //#region Inicializadores
    constructor(private changeDetectorRef: ChangeDetectorRef, private renderer: Renderer2, private connection: ConnectionService){
      this.connection.company$.subscribe((data) =>{
        if(data){
          this.company = data;
          this.imgString = this.company.company.logo;
        }
      })
    }

    ngOnInit(){
      if(this.company){
        this.preloadedImage = new Image();
        this.preloadedImage.src = this.company.company.logo;
      }

      // this.preloadedImage.src = './assets/logo/Gif/animation-logo.gif';
    }

    ngAfterViewInit(){
    }

    ngOnDestroy(): void {
      this.imgString = ''
    }

    // loadImgComplete(event: Event){
    //   const element = event.target as HTMLImageElement;
    //   this.renderer.addClass(element, 'complete')
    // }

    loadImgComplete(event: Event){
      const element = event.target as HTMLImageElement;

      this.imgLoaded = true;
      this.renderer.addClass(element, 'complete')

    }


    replaceWithStaticImage() {
      // this.imgString = '../../../../assets/logo/logo-pedeaqui.png';
      this.imgString = this.company.company.logo;
      this.changeDetectorRef.detectChanges();
    }
  //#endregion

  //#region Funções de estilo (Style)
  //#endregion

  //#region Funções de lógica (Logic)
  //#endregion











}
